import ResidentContent from "./ResidentContent";
import "./ResidentContent.scss";

export default ResidentContent;